<template>
  <el-cascader
    v-model="selected"
    v-bind="$attrs"
    :options="options"
    @change="change"
    placeholder="请选择级别"
  ></el-cascader>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selected: [],
      options: []
    }
  },
  created () {
    this.options = ['P', 'M'].map(x => {
      return {
        value: x,
        label: x,
        children: [...Array(10).keys()].filter(x => x > 0).map(x => {
          return {
            value: `${x}`,
            label: x,
            children: ['+', '-', '0'].map((x, index) => {
              return {
                value: x === '0' ? '' : x,
                label: x
              }
            })
          }
        })
      }
    })
  },
  watch: {
    value (val) {
      this.selected = val.split('').concat(val.length === 2 ? [''] : [])
    }
  },
  methods: {
    change (val) {
      this.$emit('input', val.join(''))
    }
  }
}
</script>
